/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';
// import { useCookies } from 'react-cookie'; // ไม่ได้ใช้ใน logic นี้ ตัดออกได้ถ้าไม่จำเป็น

const API_URL = import.meta.env.VITE_API_URL;

function Token() {
  const { data, setData } = useDataContext();
  
  // ใช้ useRef ป้องกันการยิงซ้ำ (React Strict Mode Safety)
  const hasFetched = useRef(false);

  useEffect(() => {
    // 1. เช็คว่ามีข้อมูลใน Context หรือยัง ถ้ามีแล้ว ให้หยุดทำงาน (ไม่ยิง API)
    if (data.docOther && data.docOther.length > 0) {
        return;
    }

    // 2. กันยิงซ้ำรอบสอง
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const myHeaders = new Headers();
        // Basic Auth ตามโค้ดเดิม
        myHeaders.append("Authorization", "Basic SHJAYm9vbnNpcmkuY28udGg6SHJAYnNyISEh");

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow"
        };

        const response = await fetch(`${API_URL}/documents`, requestOptions);
        const result = await response.json();
        
        setData(prevData => ({ ...prevData, docOther: result.data || [] }));
        
      } catch (error) {
        console.error("Error fetching documents:", error);
        hasFetched.current = false;
      }
    };

    fetchData();

  }, []); // Run once on mount
    
  return null;
}

export default Token;